import React, { Component } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf } from '@fortawesome/free-solid-svg-icons';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

const MODAL_HEADER_HEIGHT = 60;
const MODAL_BODY_VPAD = 32;
const MODAL_BODY_HPAD = 32;
const MAX_MODAL_HEIGHT_VH = 0.9;
const MAX_MODAL_WIDTH_PX = 1140;

class PdfPreview extends Component {
    state = {
        isOpen: false,
        numPages: null,
        thumbError: false,
        pageWidth: null
    }

    toggle = (e) => {
        if (e) e.preventDefault();
        if (this.props.noModal) return;
        this.setState({ isOpen: !this.state.isOpen, pageWidth: null });
    }

    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    onFirstPageLoadSuccess = (page) => {
        const availableWidth = Math.min(MAX_MODAL_WIDTH_PX, window.innerWidth - 80) - MODAL_BODY_HPAD;
        const availableHeight = (window.innerHeight * MAX_MODAL_HEIGHT_VH) - MODAL_HEADER_HEIGHT - MODAL_BODY_VPAD;
        const aspect = page.width / page.height;
        const widthByHeight = availableHeight * aspect;
        const fitWidth = Math.max(120, Math.min(availableWidth, widthByHeight));
        this.setState({ pageWidth: fitWidth });
    }

    onThumbError = () => {
        this.setState({ thumbError: true });
    }

    render() {
        const { file, thumbnailWidth = 70, title, noModal } = this.props;
        const { isOpen, numPages, thumbError, pageWidth } = this.state;

        if (!file) return null;

        const thumbStyle = {
            cursor: noModal ? 'default' : 'pointer',
            display: 'inline-block',
            border: '1px solid #ddd',
            borderRadius: '4px',
            overflow: 'hidden',
            background: '#fff',
            lineHeight: 0,
            width: thumbnailWidth
        };

        const placeholderStyle = {
            width: thumbnailWidth,
            height: Math.round(thumbnailWidth * 1.3),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#6c757d',
            fontSize: '11px',
            textAlign: 'center',
            padding: '4px'
        };

        const modalBodyHeight = `calc(${MAX_MODAL_HEIGHT_VH * 100}vh - ${MODAL_HEADER_HEIGHT}px)`;

        return (
            <React.Fragment>
                <div
                    onClick={this.toggle}
                    style={thumbStyle}
                    title={noModal ? (title || '') : 'Click to preview'}
                >
                    {thumbError ? (
                        <div style={placeholderStyle}>
                            <FontAwesomeIcon icon={faFilePdf} size="2x" />
                        </div>
                    ) : (
                        <Document
                            file={file}
                            loading={<div style={placeholderStyle}>Loading…</div>}
                            error={<div style={placeholderStyle}><FontAwesomeIcon icon={faFilePdf} size="2x" /></div>}
                            onLoadError={this.onThumbError}
                            onSourceError={this.onThumbError}
                        >
                            <Page
                                pageNumber={1}
                                width={thumbnailWidth}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                            />
                        </Document>
                    )}
                </div>
                {!noModal && (
                    <Modal isOpen={isOpen} toggle={this.toggle} size="xl" centered>
                        <ModalHeader toggle={this.toggle}>{title || 'PDF Preview'}</ModalHeader>
                        <ModalBody style={{ textAlign: 'center', height: modalBodyHeight, overflow: 'auto', background: '#f5f5f5', padding: `${MODAL_BODY_VPAD / 2}px ${MODAL_BODY_HPAD / 2}px` }}>
                            {isOpen && (
                                <Document
                                    file={file}
                                    loading={<div className="p-4">Loading PDF…</div>}
                                    error={<div className="p-4 text-danger">Failed to load PDF.</div>}
                                    onLoadSuccess={this.onDocumentLoadSuccess}
                                >
                                    {Array.from(new Array(numPages || 1), (el, index) => (
                                        <div key={`page_wrap_${index + 1}`} style={{ marginBottom: '12px', display: 'inline-block', boxShadow: '0 2px 6px rgba(0,0,0,0.15)' }}>
                                            <Page
                                                pageNumber={index + 1}
                                                width={pageWidth || undefined}
                                                onLoadSuccess={index === 0 ? this.onFirstPageLoadSuccess : undefined}
                                            />
                                        </div>
                                    ))}
                                </Document>
                            )}
                        </ModalBody>
                    </Modal>
                )}
            </React.Fragment>
        );
    }
}

export default PdfPreview;
